import { IPortalProps } from 'components/Portal/Portal.types';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';

export class Portal extends React.Component<IPortalProps> {
  el: HTMLDivElement;
  constructor(props: IPortalProps) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    const { targetElement } = this.props;
    if (!targetElement) return;
    targetElement.appendChild(this.el);
  }

  componentWillUnmount() {
    const { targetElement } = this.props;
    if (!targetElement) return;
    try {
      if (this.el.parentNode === targetElement) {
        targetElement.removeChild(this.el);
      }
    } catch {
      // Silently handle DOM cleanup errors during unmount
    }
  }

  render() {
    const { children } = this.props;

    if (!this.el) return <Fragment />;
    return ReactDOM.createPortal(children, this.el);
  }
}
